//
//
//
//
//
//

export default {
  name: 'CirclesToRhombusesSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1200
    },
    circleSize: {
      type: Number,
      default: 15
    },
    color: {
      type: String,
      default: '#fff'
    },
    circlesNum: {
      type: Number,
      default: 3
    }
  },

  computed: {
    circleMarginLeft () {
      return this.circleSize * 1.125
    },

    spinnertStyle () {
      return {
        height: `${this.circleSize}px`,
        width: `${(this.circleSize + this.circleMarginLeft) * this.circlesNum}px`
      }
    },

    circleStyle () {
      return {
        borderColor: this.color,
        animationDuration: `${this.animationDuration}ms`,
        height: `${this.circleSize}px`,
        width: `${this.circleSize}px`,
        marginLeft: `${this.circleMarginLeft}px`
      }
    },

    circlesStyles () {
      const circlesStyles = []
      const delay = 150

      for (let i = 1; i <= this.circlesNum; i++) {
        const style = Object.assign({
          animationDelay: `${i * delay}ms`
        }, this.circleStyle)

        if (i === 1) {
          style.marginLeft = 0
        }

        circlesStyles.push(style)
      }

      return circlesStyles
    }
  }
}
